module.exports = __webpack_public_path__ + "static/img/314_TO8_2310.d8dfe04.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/314_TO8_2310.jpg
// module id = bxcS
// module chunks = 0